module.exports = __webpack_public_path__ + "images/opp.png?d9f243cfe45049c8488bfc90fa0133ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opp.png
// module id = 52
// module chunks = 0